document.addEventListener('DOMContentLoaded', function () {
  // El script se incluye desde varias secciones; garantizamos una sola inicialización.
  if (window.__mtInit) return;
  window.__mtInit = true;
  initReveal();
  initCifras();
  initGaleriaProducto();
  initVariantesProducto();
  initCantidadProducto();
  initBuybar();
  initParallax();
  initTilt();
  initCountdown();
  initCarousel();
  initPacks();
  initCod();
  initAutoCarousel();
  initExitPopup();
});

/* Popup de recuperación al cerrar el formulario de pedido (Releasit COD Form&Upsell).
 *
 * Releasit renderiza su modal como <dialog id="rsi_form_wrapper" class="... rsi-form-wrapper-dialog
 * _rsi_main_form_dialog_element">. Al pulsar su botón de cerrar (clase estable
 * `.rsi-form-close-button`; el resto de clases son hashes de styled-components que cambian con
 * cada actualización de la app) Releasit pone `dialog.open = false` a mano en vez de llamar a
 * `dialog.close()`, así que el evento nativo `close` del <dialog> NUNCA se dispara — hay que
 * escuchar el click del botón, delegado en document porque el diálogo no existe hasta que el
 * cliente abre el formulario por primera vez.
 *
 * Comprobado también que NO se puede reabrir el formulario poniendo dialog.open = true a mano:
 * Releasit desmonta el contenido del formulario por su cuenta (estado interno de React), así que
 * el diálogo queda vacío. Por eso el botón "Volver a mi pedido" del popup solo cierra el popup —
 * el cliente pulsa Comprar de nuevo si quiere terminar el pedido.
 */
function initExitPopup() {
  var CODIGO = 'VUELVE10';
  var mostrado = false;

  document.addEventListener('click', function (e) {
    if (mostrado) return;
    if (!e.target.closest('.rsi-form-close-button')) return;
    // Si el cliente ya pagó, Releasit no muestra este botón sobre un formulario recién enviado
    // con éxito (pasa a otra pantalla propia), así que este cierre es siempre un abandono real.
    mostrado = true;
    try { sessionStorage.setItem('mtExitPopupShown', '1'); } catch (err) {}
    mostrarExitPopup(CODIGO);
  });

  // No molestar dos veces en la misma sesión de navegación.
  try { if (sessionStorage.getItem('mtExitPopupShown')) mostrado = true; } catch (err) {}
}

function mostrarExitPopup(codigo) {
  var overlay = document.createElement('div');
  overlay.className = 'mt-exit-popup';
  overlay.innerHTML =
    '<div class="mt-exit-popup__card" role="dialog" aria-modal="true" aria-label="Descuento especial">' +
      '<button type="button" class="mt-exit-popup__x" aria-label="Cerrar">&times;</button>' +
      '<div class="mt-exit-popup__badge">🎉 ¡Felicidades!</div>' +
      '<h3 class="mt-exit-popup__title">Ganaste 10% de descuento</h3>' +
      '<p class="mt-exit-popup__texto">Antes de que te vayas: usa este código y te lo aplicamos cuando te confirmemos tu pedido por WhatsApp.</p>' +
      '<div class="mt-exit-popup__codigo">' +
        '<span class="mt-exit-popup__codigo-texto">' + codigo + '</span>' +
        '<button type="button" class="mt-btn mt-btn--secundario mt-exit-popup__copiar">Copiar</button>' +
      '</div>' +
      '<button type="button" class="mt-btn mt-btn--primario mt-exit-popup__volver">Volver a mi pedido</button>' +
    '</div>';
  document.body.appendChild(overlay);
  document.body.style.overflow = 'hidden';
  void overlay.offsetWidth;
  overlay.classList.add('is-open');

  function cerrar() {
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () { overlay.remove(); }, 250);
  }

  overlay.querySelector('.mt-exit-popup__x').addEventListener('click', cerrar);
  overlay.querySelector('.mt-exit-popup__volver').addEventListener('click', cerrar);
  overlay.addEventListener('click', function (e) { if (e.target === overlay) cerrar(); });
  document.addEventListener('keydown', function esc(e) {
    if (e.key === 'Escape') { cerrar(); document.removeEventListener('keydown', esc); }
  });

  var copiarBtn = overlay.querySelector('.mt-exit-popup__copiar');
  copiarBtn.addEventListener('click', function () {
    var listo = function () {
      copiarBtn.textContent = '¡Copiado!';
      setTimeout(function () { copiarBtn.textContent = 'Copiar'; }, 1800);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(codigo).then(listo, listo);
    } else {
      var tmp = document.createElement('textarea');
      tmp.value = codigo; tmp.style.position = 'fixed'; tmp.style.opacity = '0';
      document.body.appendChild(tmp); tmp.select();
      try { document.execCommand('copy'); } catch (err) {}
      document.body.removeChild(tmp);
      listo();
    }
  });
}

/* Carrusel que rota solo, mostrando un elemento a la vez */
function initAutoCarousel() {
  document.querySelectorAll('[data-mt-auto]').forEach(function (car) {
    var track = car.querySelector('[data-mt-auto-track]');
    var dotsWrap = car.querySelector('[data-mt-auto-dots]');
    if (!track) return;
    var slides = track.children;
    if (slides.length <= 1) { if (dotsWrap) dotsWrap.style.display = 'none'; return; }
    var intervalo = parseInt(car.dataset.mtAutoIntervalo, 10) || 3000;
    var i = 0, timer = null;
    var dots = [];
    if (dotsWrap) {
      for (var k = 0; k < slides.length; k++) {
        var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Ver ' + (k + 1));
        (function (idx) { b.addEventListener('click', function () { go(idx, true); }); })(k);
        dotsWrap.appendChild(b); dots.push(b);
      }
    }
    function paint() { dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === i); }); }
    function go(idx, manual) {
      i = (idx + slides.length) % slides.length;
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
      paint();
      if (manual) restart();
    }
    function next() { go(i + 1); }
    function start() { if (!timer) timer = setInterval(next, intervalo); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function restart() { stop(); start(); }
    track.addEventListener('scroll', function () {
      var c = Math.round(track.scrollLeft / track.clientWidth);
      if (c !== i) { i = c; paint(); }
    }, { passive: true });
    car.addEventListener('mouseenter', stop);
    car.addEventListener('mouseleave', start);
    car.addEventListener('touchstart', stop, { passive: true });
    paint();
    start();
  });
}

/* Formulario de contra entrega: abre modal al comprar y envía el pedido por WhatsApp */
function initCod() {
  var modal = document.querySelector('[data-mt-cod-modal]');
  if (!modal) return;
  var wa = (modal.dataset.mtWhatsapp || '').replace(/\D/g, '');
  var baseTitle = modal.dataset.mtTitle || 'Pedido';
  var basePrice = parseInt(modal.dataset.mtPrice, 10) || 0;
  var resumenEl = modal.querySelector('[data-mt-cod-resumen]');
  var form = modal.querySelector('[data-mt-cod-form]');
  var fmt = function (n) { return '$' + Number(n).toLocaleString('es-CL'); };

  function abrir(qty, total) {
    modal.dataset.qty = qty;
    modal.dataset.total = total;
    if (resumenEl) resumenEl.textContent = qty + (qty > 1 ? ' unidades' : ' unidad') + ' · ' + fmt(total);
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    void modal.offsetWidth;
    modal.classList.add('is-open');
  }
  function cerrar() {
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () { modal.hidden = true; }, 250);
  }
  function opener(e) {
    e.preventDefault();
    var btn = e.currentTarget;
    var scope = btn.closest('form') || btn.closest('[data-mt-producto-form]') || document;
    var qtyInput = scope.querySelector ? scope.querySelector('[data-mt-qty-input]') : null;
    var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
    var pack = scope.querySelector ? scope.querySelector('[data-mt-pack-op].is-active') : null;
    var total = pack && pack.dataset.total ? parseInt(pack.dataset.total, 10) : basePrice * qty;
    abrir(qty, total);
  }

  document.querySelectorAll('[data-mt-add], .mt-landing__cta, .mt-home-cta, [data-mt-cod-open]').forEach(function (btn) {
    btn.addEventListener('click', opener);
  });
  modal.querySelectorAll('[data-mt-cod-close]').forEach(function (el) { el.addEventListener('click', cerrar); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) cerrar(); });

  if (form) form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (!form.checkValidity()) { form.reportValidity(); return; }
    if (!wa) { alert('Falta configurar el número de WhatsApp de la tienda.'); return; }
    var d = new FormData(form);
    var L = [];
    L.push('¡Hola! Quiero hacer un pedido (pago contra entrega):');
    L.push('');
    L.push('🛒 ' + baseTitle);
    L.push('Cantidad: ' + modal.dataset.qty);
    L.push('Total: ' + fmt(modal.dataset.total));
    L.push('');
    L.push('👤 ' + d.get('nombre') + ' ' + d.get('apellido'));
    L.push('📱 ' + d.get('whatsapp'));
    L.push('📍 ' + d.get('direccion') + (d.get('referencia') ? (' — Ref: ' + d.get('referencia')) : ''));
    L.push('🏙️ ' + d.get('comuna') + ', ' + d.get('region'));
    window.location.href = 'https://wa.me/' + wa + '?text=' + encodeURIComponent(L.join('\n'));
  });
}

/* Selector de packs: ajusta la cantidad del formulario al elegir */
function initPacks() {
  document.querySelectorAll('[data-mt-pack]').forEach(function (pack) {
    var ops = pack.querySelectorAll('[data-mt-pack-op]');
    var scope = pack.closest('form') || document;
    var qtyInput = scope.querySelector('[data-mt-qty-input]');
    ops.forEach(function (op) {
      op.addEventListener('click', function () {
        ops.forEach(function (o) { o.classList.remove('is-active'); });
        op.classList.add('is-active');
        var radio = op.querySelector('input[type=radio]');
        if (radio) radio.checked = true;
        if (qtyInput) qtyInput.value = op.dataset.qty || 1;
      });
    });
  });
}

/* Carrusel deslizable de la portada (estilo Mercado Libre) */
function initCarousel() {
  document.querySelectorAll('[data-mt-carousel]').forEach(function (car) {
    var track = car.querySelector('[data-mt-carousel-track]');
    var dotsWrap = car.querySelector('[data-mt-carousel-dots]');
    var prev = car.querySelector('[data-mt-carousel-prev]');
    var next = car.querySelector('[data-mt-carousel-next]');
    var slides = track ? track.children : [];

    if (!track || slides.length <= 1) {
      if (dotsWrap) dotsWrap.style.display = 'none';
      if (prev) prev.style.display = 'none';
      if (next) next.style.display = 'none';
      return;
    }

    var dots = [];
    for (var i = 0; i < slides.length; i++) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'mt-landing__dot-nav';
      b.setAttribute('aria-label', 'Ir a la imagen ' + (i + 1));
      (function (idx) {
        b.addEventListener('click', function () {
          track.scrollTo({ left: idx * track.clientWidth, behavior: 'smooth' });
        });
      })(i);
      if (dotsWrap) dotsWrap.appendChild(b);
      dots.push(b);
    }

    function update() {
      var c = Math.round(track.scrollLeft / track.clientWidth);
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === c); });
    }
    track.addEventListener('scroll', update, { passive: true });
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth, behavior: 'smooth' }); });
    update();
  });
}

/* Cuenta atrás de la barra de oferta (en horas, se reinicia por navegador) */
function initCountdown() {
  document.querySelectorAll('[data-mt-countdown-horas]').forEach(function (el) {
    var horas = parseFloat(el.dataset.mtCountdownHoras) || 8;
    var dur = horas * 3600000;
    var key = 'mt_oferta_deadline';
    function leer() {
      var now = Date.now();
      var d = 0;
      try { d = parseInt(localStorage.getItem(key) || '0', 10); } catch (e) { d = 0; }
      if (!d || d < now || d - now > dur) {
        d = now + dur;
        try { localStorage.setItem(key, d); } catch (e) {}
      }
      return d;
    }
    var deadline = leer();
    var hh = el.querySelector('[data-h]'), mm = el.querySelector('[data-m]'), ss = el.querySelector('[data-s]');
    var pad = function (n) { return ('0' + n).slice(-2); };
    function tick() {
      var diff = deadline - Date.now();
      if (diff <= 0) {
        deadline = Date.now() + dur;
        try { localStorage.setItem(key, deadline); } catch (e) {}
        diff = dur;
      }
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      if (hh) hh.textContent = pad(h);
      if (mm) mm.textContent = pad(m);
      if (ss) ss.textContent = pad(s);
    }
    tick();
    setInterval(tick, 1000);
  });
}

var MT_REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

/* Revela con animación cualquier .mt-reveal cuando entra en pantalla */
function initReveal() {
  var items = document.querySelectorAll('.mt-reveal');
  if (!items.length) return;

  if (MT_REDUCE) {
    items.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );

  items.forEach(function (el, i) {
    if (!el.hasAttribute('data-mt-delay')) el.style.setProperty('--mt-delay', i % 6);
    else el.style.setProperty('--mt-delay', el.getAttribute('data-mt-delay'));
    observer.observe(el);
  });
}

/* Cuenta hacia arriba los números con [data-mt-cifra] al entrar en pantalla */
function initCifras() {
  var items = document.querySelectorAll('[data-mt-cifra]');
  if (!items.length) return;

  var animate = function (el) {
    var to = parseFloat(el.dataset.mtCifra) || 0;
    var decimals = el.dataset.mtDecimales ? parseInt(el.dataset.mtDecimales, 10) : 0;
    var duration = 1500;
    var start = null;

    if (MT_REDUCE) { el.textContent = to.toFixed(decimals); return; }

    function step(ts) {
      if (!start) start = ts;
      var progress = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      el.textContent = (to * eased).toFixed(decimals);
      if (progress < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  };

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) { animate(entry.target); observer.unobserve(entry.target); }
    });
  }, { threshold: 0.5 });

  items.forEach(function (el) { observer.observe(el); });
}

/* Galería del producto: cambia la imagen principal al pulsar una miniatura */
function initGaleriaProducto() {
  document.querySelectorAll('[data-mt-galeria]').forEach(function (galeria) {
    var main = galeria.querySelector('[data-mt-galeria-main]');
    var thumbs = galeria.querySelectorAll('[data-mt-galeria-thumb]');
    if (!main || !thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var fullSrc = thumb.dataset.mtGaleriaThumb;
        if (!fullSrc) return;
        main.src = fullSrc;
        var innerImg = thumb.querySelector('img');
        if (innerImg) main.alt = innerImg.alt;
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  });
}

/* Selector de variantes: actualiza precio (formateado por Shopify), id y estado agotado */
function initVariantesProducto() {
  document.querySelectorAll('[data-mt-producto-form]').forEach(function (formWrap) {
    var dataEl = formWrap.querySelector('[data-mt-variantes-json]');
    var preciosEl = formWrap.querySelector('[data-mt-precios-json]');
    if (!dataEl) return;

    var variants, precios;
    try {
      variants = JSON.parse(dataEl.textContent);
      precios = preciosEl ? JSON.parse(preciosEl.textContent) : {};
    } catch (e) { return; }

    var pills = formWrap.querySelectorAll('[data-mt-pill]');
    var idInput = formWrap.querySelector('[data-mt-variant-id]');
    var addBtn = formWrap.querySelector('[data-mt-add]');
    var addLabel = formWrap.querySelector('[data-mt-add-label]');
    var precioActual = formWrap.querySelector('[data-mt-precio-actual]');
    var precioAnterior = formWrap.querySelector('[data-mt-precio-anterior]');
    var stockNota = formWrap.querySelector('[data-mt-stock-nota]');
    var buybarPrecio = document.querySelector('[data-mt-buybar-precio]');
    var buybarAnterior = document.querySelector('[data-mt-buybar-anterior]');
    var buybarAdd = document.querySelector('[data-mt-buybar-add]');

    var selecciones = {};
    pills.forEach(function (pill) {
      var input = pill.querySelector('input');
      if (input && input.checked) selecciones[pill.dataset.mtOptionName] = pill.dataset.mtOptionValue;
    });

    function optionName(i) { return formWrap.dataset['mtOptionName' + i]; }

    function encuentra(sel) {
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return sel[optionName(i)] === opt; });
      });
    }

    function actualizar() {
      // Deshabilita combinaciones inexistentes
      pills.forEach(function (pill) {
        var testSel = Object.assign({}, selecciones);
        testSel[pill.dataset.mtOptionName] = pill.dataset.mtOptionValue;
        pill.classList.toggle('is-disabled', !encuentra(testSel));
      });

      var match = encuentra(selecciones);
      if (!match) return;
      if (idInput) idInput.value = match.id;

      var p = precios[match.id] || {};
      if (precioActual && p.precio) precioActual.textContent = p.precio;
      if (precioAnterior) {
        if (p.tiene_comparar) { precioAnterior.textContent = p.comparar; precioAnterior.hidden = false; }
        else { precioAnterior.hidden = true; }
      }
      if (buybarPrecio && p.precio) buybarPrecio.textContent = p.precio;
      if (buybarAnterior) {
        if (p.tiene_comparar) { buybarAnterior.textContent = p.comparar; buybarAnterior.hidden = false; }
        else { buybarAnterior.hidden = true; }
      }

      var disponible = match.available;
      if (addBtn) {
        addBtn.disabled = !disponible;
        if (addLabel) addLabel.textContent = disponible ? addLabel.dataset.mtLabelDisponible : addLabel.dataset.mtLabelAgotado;
      }
      if (buybarAdd) buybarAdd.disabled = !disponible;
      if (stockNota) stockNota.hidden = !disponible;
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        var name = pill.dataset.mtOptionName;
        formWrap.querySelectorAll('[data-mt-option-name="' + name + '"]').forEach(function (p) { p.classList.remove('is-active'); });
        pill.classList.add('is-active');
        var input = pill.querySelector('input');
        if (input) input.checked = true;
        selecciones[name] = pill.dataset.mtOptionValue;
        actualizar();
      });
    });
  });
}

/* Botones +/- del selector de cantidad */
function initCantidadProducto() {
  document.querySelectorAll('[data-mt-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    var menos = wrap.querySelector('[data-mt-qty-menos]');
    var mas = wrap.querySelector('[data-mt-qty-mas]');
    if (!input) return;
    if (menos) menos.addEventListener('click', function () { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); });
    if (mas) mas.addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 1) + 1; });
  });
}

/* Barra de compra fija: aparece cuando la zona de compra sale de pantalla */
function initBuybar() {
  var bar = document.querySelector('[data-mt-buybar]');
  var compra = document.querySelector('[data-mt-compra]');
  var mainAdd = document.querySelector('[data-mt-add]');
  if (!bar || !compra) return;

  var barAdd = bar.querySelector('[data-mt-buybar-add]');
  if (barAdd && mainAdd) {
    barAdd.addEventListener('click', function () {
      if (barAdd.disabled) return;
      mainAdd.click();
    });
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      // Muestra la barra solo cuando la compra ha quedado por ENCIMA del viewport
      var pasado = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', pasado);
    });
  }, { threshold: 0, rootMargin: '0px 0px -80% 0px' });

  observer.observe(compra);
}

/* Parallax suave en fondos con [data-mt-parallax] */
function initParallax() {
  var items = document.querySelectorAll('[data-mt-parallax]');
  if (!items.length || MT_REDUCE) return;

  var ticking = false;
  function update() {
    items.forEach(function (el) {
      var speed = parseFloat(el.dataset.mtParallaxSpeed) || 0.15;
      var rect = el.getBoundingClientRect();
      var offset = (rect.top + rect.height / 2 - window.innerHeight / 2) * -speed;
      el.style.transform = 'translate3d(0,' + offset.toFixed(1) + 'px,0) scale(1.08)';
    });
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
  }, { passive: true });
  update();
}

/* Inclinación 3D sutil al pasar el cursor en [data-mt-tilt] */
function initTilt() {
  if (MT_REDUCE || window.matchMedia('(hover: none)').matches) return;
  document.querySelectorAll('[data-mt-tilt]').forEach(function (el) {
    var max = 6;
    el.addEventListener('mousemove', function (e) {
      var r = el.getBoundingClientRect();
      var px = (e.clientX - r.left) / r.width - 0.5;
      var py = (e.clientY - r.top) / r.height - 0.5;
      el.style.transform = 'perspective(900px) rotateY(' + (px * max).toFixed(2) + 'deg) rotateX(' + (-py * max).toFixed(2) + 'deg)';
    });
    el.addEventListener('mouseleave', function () { el.style.transform = ''; });
  });
}
